module.exports = __webpack_public_path__ + "img/w29b.1d4227ce.jpg";